module.exports = __webpack_public_path__ + "img/sua-morinaga-2-chilmil-3.4aff831b.jpg";